import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import Highlights from "./Highlights"
import Footer from "@components/Footer"
import "@styles/custom-bootstrap.scss"
import "@styles/global.scss"

const SailPointTechDemo = props => {
  return (
    <div>
      <Highlights />
      <Footer />
    </div>
  )
}

export default SailPointTechDemo
